import type { StudioCapability } from '@/features/auth/data/marketing';

/** Editorial capability tile — sign-in left panel. */
export function StatBlock({ capability }: { key?: string; capability: StudioCapability }) {
  return (
    <div className="surface-card rounded-2xl p-3">
      <p className="text-[13.5px] font-semibold text-ink-900 leading-snug">{capability.label}</p>
      <p className="text-[10.5px] text-ink-500 leading-relaxed mt-1.5">{capability.detail}</p>
    </div>
  );
}
